// store/Plans/PlansAPI.js
import Axios from "../../utils/axios";

export const savePlanAPI = async (payload) => {
  const response = await Axios.post("/plans/save", payload);
  return response.data;
};

export const readPlanAPI = async (payload = {}) => {
  const response = await Axios.post("/plans/read", payload);
  return response.data;
};

export const saveDayPlanAPI = async (payload) => {
  const response = await Axios.post("/plans/dayplans/save", payload);
  return response.data;
};
